import { put, call } from 'redux-saga/effects'
import { getCandidateProfile, patchCandidateProfile } from '../apiModules/candidateProfiles'
import { candidateProfileEntities } from '../reducks'

export function* fetchCandidateProfileEntitySaga(candidateProfileId) {
  const response = yield call(getCandidateProfile, candidateProfileId)
  yield put(candidateProfileEntities.addItem(response.result.id, response.result))
  return response
}

export function* updateCandidateProfileEntitySaga(candidateProfileId, data) {
  const response = yield call(patchCandidateProfile, candidateProfileId, data)
  yield put(candidateProfileEntities.updateItem(response.result.id, response.result))
  return response
}
